import React, { useState, useRef, useEffect } from 'react';
import Icon from '../../../components/AppIcon';



const FilterPanel = ({ filters, onFilterChange, onClearFilters, isOpen, onClose }) => {
  const [expandedTopics, setExpandedTopics] = useState({ business: true, travel: true });
  const panelRef = useRef(null);

  const topics = [
    {
      id: 'business',
      label: 'Business',
      subcategories: [
        { id: 'career-management', label: 'Career Management' },
        { id: 'team-development', label: 'Team Development' },
        { id: 'swot-analysis', label: 'SWOT Analysis' },
        { id: 'presentations', label: 'Presentations' },
        { id: 'people-management', label: 'People Management' }
      ]
    },
    {
      id: 'travel',
      label: 'Travel',
      subcategories: [
        { id: 'universal-studios', label: 'Universal Studios' },
        { id: 'disney-world', label: 'Disney World' }
      ]
    }
  ];

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (panelRef?.current && !panelRef?.current?.contains(e?.target)) {
        onClose();
      }
    };
    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [isOpen, onClose]);

  const handleTopicToggle = (topicId) => {
    const currentCategories = filters?.categories || [];
    const newCategories = currentCategories?.includes(topicId)
      ? currentCategories?.filter(id => id !== topicId)
      : [...currentCategories, topicId];
    onFilterChange({ ...filters, categories: newCategories });
  };

  const toggleExpand = (topicId) => {
    setExpandedTopics(prev => ({ ...prev, [topicId]: !prev?.[topicId] }));
  };

  if (!isOpen) return null;

  return (
    <div
      ref={panelRef}
      className="rounded-xl shadow-lg p-6 w-full md:w-auto md:max-w-2xl mb-4"
      style={{ backgroundColor: '#1e3a5f', border: '1px solid rgba(255,255,255,0.1)' }}
    >
      <div className="flex items-center justify-between mb-6">
        <h2 className="text-lg font-heading font-semibold" style={{ color: '#e2e8f0' }}>Filters</h2>
        <div className="flex items-center gap-2">
          <button
            onClick={onClearFilters}
            className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium transition-all"
            style={{ backgroundColor: 'rgba(255,255,255,0.1)', color: '#e2e8f0' }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.18)'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)'}
          >
            <Icon name="X" size={14} />
            Clear All
          </button>
          <button
            onClick={onClose}
            className="p-1.5 rounded-md transition-all"
            style={{ color: '#94a3b8' }}
            onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)'}
            onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
            aria-label="Close filters"
          >
            <Icon name="ChevronUp" size={18} />
          </button>
        </div>
      </div>
      <div className="space-y-4">
        <h3 className="text-xs font-semibold uppercase tracking-widest" style={{ color: '#94a3b8' }}>Topics</h3>
        {topics?.map((topic) => (
          <div key={topic?.id} className="space-y-2">
            <div className="flex items-center justify-between">
              <label className="flex items-center gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  checked={(filters?.categories || [])?.includes(topic?.id)}
                  onChange={() => handleTopicToggle(topic?.id)}
                  className="w-4 h-4 rounded accent-yellow-400"
                />
                <span className="font-semibold text-sm" style={{ color: '#e2e8f0' }}>{topic?.label}</span>
              </label>
              {topic?.subcategories?.length > 0 && (
                <button
                  onClick={() => toggleExpand(topic?.id)}
                  className="p-1 rounded transition-all"
                  style={{ color: '#94a3b8' }}
                  onMouseEnter={e => e.currentTarget.style.backgroundColor = 'rgba(255,255,255,0.1)'}
                  onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                  aria-label={`Toggle ${topic?.label} subcategories`}
                >
                  <Icon name={expandedTopics?.[topic?.id] ? 'ChevronUp' : 'ChevronDown'} size={14} />
                </button>
              )}
            </div>
            {topic?.subcategories?.length > 0 && expandedTopics?.[topic?.id] && (
              <div className="ml-6 space-y-2">
                {topic?.subcategories?.map((sub) => (
                  <label key={sub?.id} className="flex items-center gap-2 cursor-pointer">
                    <input
                      type="checkbox"
                      checked={(filters?.categories || [])?.includes(sub?.id)}
                      onChange={() => handleTopicToggle(sub?.id)}
                      className="w-4 h-4 rounded accent-yellow-400"
                    />
                    <span className="text-sm" style={{ color: '#cbd5e1' }}>{sub?.label}</span>
                  </label>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FilterPanel;